var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MulticastDelegate1 } from "flavr-common";
import { renderManager } from "./RenderManager";
const VR_SUPPORTED_INTERVAL = 1000;
class VRService {
    constructor() {
        this._isVRSupported = false;
        this.onVRSupportedDelegate = new MulticastDelegate1();
        this.onDeviceChange = () => {
            void this.checkIsXRSupported();
        };
        this.onSessionStarted = () => {
            this.baseReferenceSpace = renderManager.xrManager.getReferenceSpace();
        };
        this.onSessionEnded = () => {
            this.baseReferenceSpace = undefined;
        };
        if ("xr" in navigator) {
            const xr = navigator.xr;
            xr.addEventListener("devicechange", this.onDeviceChange);
        }
        renderManager.xrManager.addEventListener("sessionstart", this.onSessionStarted);
        renderManager.xrManager.addEventListener("sessionend", this.onSessionEnded);
    }
    get isVRSupported() {
        return this._isVRSupported;
    }
    changeVRSupported(isSupported) {
        this.changeIsVRSupported(isSupported);
    }
    startCheckIsVrSupportedInterval() {
        if (this.vrSupportedTimer !== undefined)
            return;
        if (this._isVRSupported)
            return;
        this.vrSupportedTimer = window.setInterval(() => {
            void this.checkIsXRSupported();
        }, VR_SUPPORTED_INTERVAL);
    }
    stopCheckIsVrSupportedInterval() {
        if (this.vrSupportedTimer === undefined)
            return;
        window.clearInterval(this.vrSupportedTimer);
    }
    checkIsXRSupported() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!("xr" in navigator)) {
                this.changeIsVRSupported(false);
                return false;
            }
            try {
                this.changeIsVRSupported(yield navigator.xr.isSessionSupported("immersive-vr"));
            }
            catch (error) {
                console.error("[xr]", error);
                this.changeIsVRSupported(false);
            }
            return this._isVRSupported;
        });
    }
    checkIsEmulatedXRDevice(session /* XRSession */) {
        renderManager.isEmulatedXRDevice = false;
        for (const sym of Object.getOwnPropertySymbols(session)) {
            if (sym.toString() === "Symbol(@@webxr-polyfill/XRSession)") {
                if (session[sym].device !== undefined) {
                    renderManager.isEmulatedXRDevice = session[sym].device.constructor.name === "EmulatedXRDevice";
                }
            }
        }
    }
    resetReferenceSpace() {
        const referenceSpace = renderManager.xrManager.getReferenceSpace();
        if (!referenceSpace) {
            console.warn("[xr] resetReferenceSpace: no reference space available to reset");
            return;
        }
        this.baseReferenceSpace = referenceSpace;
        renderManager.xrManager.setReferenceSpace(referenceSpace);
    }
    updateOriginOffset(position, quaternion) {
        if (!this.baseReferenceSpace) {
            console.warn("[xr] updateOriginOffset: can't update offset while VR isn't presenting");
            return;
        }
        const transform = new XRRigidTransform(position, quaternion);
        const refSpace = this.baseReferenceSpace.getOffsetReferenceSpace(transform);
        renderManager.xrManager.setReferenceSpace(refSpace);
    }
    changeIsVRSupported(isSupported) {
        if (isSupported === this._isVRSupported)
            return;
        if (isSupported) {
            this.stopCheckIsVrSupportedInterval();
        }
        this._isVRSupported = isSupported;
        this.onVRSupportedDelegate.invoke(isSupported);
    }
}
export const vrService = new VRService();
